import Image from 'next/image';
import useImageLoad from '@/hooks/useImageLoad';

export default function RecordsImageCollage({ className = '', image, attribution }) {
  const {imageRef, onLoad} = useImageLoad()

  return (
    <div className={`relative col-span-full lg:col-span-4 ${className}`}>
      <Image unoptimized={true} className="block relative z-1 w-full opacity-0" {...image} onLoad={onLoad} priority={true} ref={imageRef}/>
      {attribution &&
        (<p className="body-3-sans-small mt-2 text-center text-main-dark-800 xl:body-3-sans">{attribution}</p>)
      }
    </div>
  )
}
